import { Palette, PaletteColor, Theme } from '@mui/material';

export const getPaletteColor = (color: string | undefined, theme: Theme): PaletteColor => {
    if (color && theme.palette[color as keyof Palette] && (theme.palette[color as keyof Palette] as PaletteColor).main) {
        return theme.palette[color as keyof Palette] as PaletteColor;
    }
    return theme.palette.primary;
};
